import { Button, Col, Row } from "react-bootstrap"
import Header from "../Header"
import { CardContent, CardMedia, Divider } from "@mui/material"
import { url_images } from "../../lib/backend/data"
import Card from '@mui/material/Card';
import NewletterSite from "../Home/newsletter";
import SocialIcons from "../Home/socialMedia";
import FooterText from "../Home/footerText";
import { estilo_last_mile } from "../../lib/global/styles";
import { Link } from "react-router-dom";
import FormContact from "./form";

const Contacto = () => {

    const items = [
        {
            title: "Casa matriz",
            description: "Diego de Rosales 1525, Santiago Centro, Santiago, Chile",
            icon: "iconosd-03.png"
        },
    ]
    const footer = () =>{
        const newsletter = <NewletterSite />
      const social = <SocialIcons zone="social_media_footer" />
      const footer_text = <FooterText />
      if(!newsletter && !social && !footer_text) return false

      return <footer>
          <div className='p-4 bg-white'>
            <Row className='justify-content-md-center'>
            {newsletter ? <Col md={8} xs={12}>{newsletter}</Col> : false }
            {social ? <Col md={3} xs={12}>{social}</Col> : false }
            </Row>
            {footer_text ? <div className='mt-3'>{footer_text}</div> : false }
        </div>
      </footer>
    }
    return <div>
        <Header />
        <div className="p-4 container">
            <h5 className="mb-0">¡Conectemos!</h5>
            <h1 className="bold" style={{ fontSize: 50, color: estilo_last_mile.color_secondary }}>Contacto</h1>
            <Divider sx={{ mb:2, mt:2 }} />
            <Row className="align-items-center">
                <Col md={6} xs={12}>
                <p style={{ fontSize: 25, fontWeight: 300 }}>Queremos ofrecerte la mejor experiencia posible, por eso cuéntanos cómo podemos asistirte</p>
                <FormContact />
                <Row className="align-items-center mt-3">
                {items.map((item, index) => <Col className="mb-4" key={index}>
                    {/* { item.icon ? <img src={`${url_images}/chocolateandino/${item.icon}`} alt={item.title} style={{ width: 100, height: 100 }} /> : false } */}
                    <h4>{item.title}</h4>
                    <p style={{ fontSize: 12 }}>{item.description}</p>
                </Col>)}
            </Row>
                </Col>
                <Col md={6} xs={12}>
                <Card>
                    <CardMedia
                        component="img"
                        height="100%"
                        image={`${url_images}/chocolateandino/manos.png`}
                        alt="Equipo Chocolate Andino"
                    />
                </Card>
                </Col>
            </Row>
            {/* <div className="text-center p-4">
                <p>En cada trozo de nuestro chocolate, está lo mejor de un viaje desde Piura hasta los hogares de nuestras consumidores en Chile, una historia de sabor refinado y placer sin culpas, donde la calidad y el compromiso con la salud se entrelazan en una experiencia única. </p>
                <h4>Somos más que una marca de chocolates; somos el testimonio de que es posible disfrutar de los pequeños placeres de la vida sin sacrificar la salud.</h4>
            </div> */}

        </div>
    {footer()}
    </div>
}

export default Contacto